import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";
import { GetAllReferralDataResponse } from "../models/Referral/GetAllReferralDataModel";

class ReferralApiService {
  private api: AxiosInstance;

  constructor() {
    this.api = createApiClient();
  }

  public async getAllReferralData(): Promise<GetAllReferralDataResponse> {
    const response = await this.api.get<GetAllReferralDataResponse>(
      "/cashierReferralProgram/adminPanel/getAllReferralData"
    );
    return response.data;
  }
}

export const referralApis = new ReferralApiService();
